export const REPORTS_DATABASE_NAME = 'reportsReadStatus';
export const REPORTS_DATABASE_VERSION = 1;
export const REPORTS_DATABASE_OBJECT_STORE_NAME = 'userReports';
export const REPORTS_DATABASE_OBJECT_STORE_KEY = 'authId';
